import { useTranslation } from 'react-i18next';
import {
  ClipboardList,
  Stethoscope,
  History,
  Image,
  Activity,
} from 'lucide-react';

export type DentalView = 'plan' | 'session' | 'history' | 'imaging' | 'perio';

interface Tab {
  id: DentalView;
  labelKey: string;
  icon: React.ComponentType<{ className?: string }>;
  disabled?: boolean;
  disabledTitle?: string;
}

const TABS: Tab[] = [
  { id: 'plan', labelKey: 'dental.module.tabs.plan', icon: ClipboardList },
  { id: 'session', labelKey: 'dental.module.tabs.session', icon: Stethoscope },
  { id: 'history', labelKey: 'dental.module.tabs.history', icon: History },
  { id: 'imaging', labelKey: 'dental.module.tabs.imaging', icon: Image },
  { id: 'perio', labelKey: 'dental.module.tabs.perio', icon: Activity },
];

interface DentalSubNavProps {
  activeView: DentalView;
  onChange: (view: DentalView) => void;
}

export function DentalSubNav({
  activeView,
  onChange,
}: DentalSubNavProps) {
  const { t } = useTranslation();

  return (
    <div className="sticky top-14 z-20 border-b border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-900">
      <nav className="-mb-px flex gap-0 overflow-x-auto px-4" aria-label="Dental sub-navigation">
        {TABS.map((tab) => {
          const isDisabled = false;
          const isActive = activeView === tab.id;
          const Icon = tab.icon;

          return (
            <button
              key={tab.id}
              disabled={isDisabled}
              onClick={() => onChange(tab.id)}
              className={`
                flex shrink-0 items-center gap-2 border-b-2 px-4 py-3 text-sm font-medium transition-colors
                ${
                  isActive
                    ? 'border-indigo-500 text-indigo-600 dark:border-indigo-400 dark:text-indigo-400'
                    : isDisabled
                      ? 'cursor-not-allowed border-transparent text-gray-300 dark:text-gray-600'
                      : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-gray-400 dark:hover:border-gray-600 dark:hover:text-gray-300'
                }
              `}
              aria-current={isActive ? 'page' : undefined}
            >
              <Icon className="h-4 w-4" />
              {t(tab.labelKey)}
            </button>
          );
        })}
      </nav>
    </div>
  );
}
